module.exports = __webpack_public_path__ + "img/search.41e9c8f9.svg";